import type { SVGProps } from "react";

const BohemiaSymbol = (props: SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 37.21 39.69"
        width="1em"
        height="1em"
        fill="currentColor"
        {...props}
    >
        <path
            d="m28.88 21.22.06-.18c1.13-3.69.68-7.11-1.28-9.62A9.37 9.37 0 0 0 21.85 8L25 0h-2.41s-1.15 3.74-2.53 7.82a13.49 13.49 0 0 0-1.42 0A20.12 20.12 0 0 0 7.5 12.26 18.71 18.71 0 0 0 1.73 19h2a17.17 17.17 0 0 1 4.67-5.57A18.71 18.71 0 0 1 18.71 9.3h.85c-.16.47-.33.93-.49 1.39-.63 1.77-2.13 5.92-3.81 10.54H9.72l-2.5 3.52a37.48 37.48 0 0 1 7.29-1.44c-1.32 3.63-2.68 7.37-3.76 10.36-3.37.19-6.38-.8-8.25-2.93A7 7 0 0 1 .81 27.5L0 26.74a8.67 8.67 0 0 0 1.76 4.88A10.18 10.18 0 0 0 10 35.21h.15l-1.59 4.48 1-.77 1.49-3.75a20.31 20.31 0 0 0 10.84-4.4 20.72 20.72 0 0 0 6.54-8.4h7.96l.78-1.11ZM21.3 9.43a8.1 8.1 0 0 1 5.2 2.89c1.65 2.13 2 5.07 1 8.29-.06.2-.13.41-.2.61H16.62ZM21 29.61a19 19 0 0 1-9.3 4l4.14-10.43c2.83-.32 6.45-.6 11-.73A19.63 19.63 0 0 1 21 29.61Z"
            data-name="Layer 1"
        />
    </svg>
);

export default BohemiaSymbol;
